import UibookStarter from 'uibook/starter'
import React from 'react'

import PopupUibook from './popup.uibook'
import TelegramButtonModesUibook from './telegram-button-modes.uibook'
import TelegramButtonSizesUibook from './telegram-button-sizes.uibook'
import TelegramButtonStatesUibook from './telegram-button-states.uibook'
import TelegramChipModesUibook from './telegram-chip-modes.uibook'
import TelegramChipContentUibook from './telegram-chip-content.uibook'
import TelegramChipStatesUibook from './telegram-chip-states.uibook'
import TelegramBadgeModesUibook from './telegram-badge-modes.uibook'
import TelegramBadgeTypesUibook from './telegram-badge-types.uibook'
import TelegramBadgeStatesUibook from './telegram-badge-states.uibook'
import AiSettingsPopupPresetsUibook from './ai-settings-popup-presets.uibook'
import AiSettingsPopupWorkflowUibook from './ai-settings-popup-workflow.uibook'
import AiSettingsPopupSafetyUibook from './ai-settings-popup-safety.uibook'

import Context from '../Context'

export default UibookStarter({
  wrapper: (children, props) =>
    <Context.Provider value={ props }>
      { children }
    </Context.Provider>,
  values: {
    locale: ['ru', 'en'],
    theme: ['dark', 'light']
  },
  pages: {
    Popups: {
      Popup: PopupUibook
    },
    Button: {
      Modes: TelegramButtonModesUibook,
      Sizes: TelegramButtonSizesUibook,
      States: TelegramButtonStatesUibook
    },
    Chip: {
      Content: TelegramChipContentUibook,
      Decorators: TelegramChipModesUibook,
      Behavior: TelegramChipStatesUibook
    },
    Badge: {
      Variants: TelegramBadgeModesUibook,
      Types: TelegramBadgeTypesUibook,
      Statuses: TelegramBadgeStatesUibook
    },
    AiSettingsPopup: {
      Presets: AiSettingsPopupPresetsUibook,
      Workflow: AiSettingsPopupWorkflowUibook,
      Guardrails: AiSettingsPopupSafetyUibook
    }
  }
})
